const formatEuro = input => {
  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR"
  })
    .format(input)
    .replace(",00", ",-");
};

const formatThousands = input => {
  return input.toLocaleString("nl-NL");
};

export { formatEuro, formatThousands };
